<template>
    <div>
        <a-row :gutter="24" type="flex">
            <a-col :span="24" class="mb-24">
                <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
                    <template #title>
                        <a-row type="flex" align="middle">
                            <a-col :span="24" :md="12">
                                <h5 class="font-semibold m-0">

                                      جدول قرعه کشی مهمانان {{ info . title }}

                                </h5>
                            </a-col>
                            <a-col :span="24" :md="12"
                                style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                ">
                                <a-button target="_blank" :href="$store.state.baseUrl+'/sans-export/'+$route.params.id+'?present=1'">
                                        <a-icon type="upload" />  خروجی اکسل مهمانان 
                                    </a-button>

                            </a-col>
                        </a-row>
                    </template>

                   
                    <a-row style="justify-content: center; display: flex" v-if="$store.state.loading">
                        <template>
                            <div>
                                <a-spin />
                            </div>
                        </template>
                    </a-row>
                    <div v-else>
                        <section class="w-100 p-4 text-center">
                            <div class="table-responsive">

                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">ردیف</th>
                                        <th scope="col">شناسه</th>
                                        <th scope="col">شماره موبایل</th>
                                        <th scope="col"> نام و نام خانوادگی</th>
                                        <th scope="col"> تماس گیرنده </th>
                                        <th scope="col"> تعداد همراه</th>
                                
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="row,index in data" >
                                        <th scope="row">{{ index+1 }}</th>
                                        <th scope="row">#{{ row.id }}</th>
                                        <td>{{ row.phone }}</td>
                                        <td>
                                            <b-badge variant="light" class="text-dark">{{ row.name+' '+row.family }} </b-badge>
                                        </td>
                                        <td>
                                            <b-badge variant="light" class="text-dark">{{row.caller ?  $root.full_name(row . caller . firstname , row . caller . lastname) : '' }}</b-badge>
                                        </td>
                                        <td>
                                            {{ row.count }}
                                        </td>
                                     
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                        </section>
                        <a-row class="pagination">
                            <a-pagination :total="total" :item-render="$root.itemRender"
                                @change="getData(currentPage)" v-model="currentPage" />
                        </a-row> 
                    </div>
                </a-card>
            </a-col>
        </a-row>
    </div>
</template>

<script>
    import GuestModal from '../../components/Seminars/ModalGuest.vue';
    import UploadModal from '../../components/Seminars/ModalUpload.vue';


    export default {
        components: {
            GuestModal,
            UploadModal,
        },
        data() {
            return {
                data: [],
                users: [],
                currentPage: 1,
                total: 0,
                isHidden: false,
                search: {
                    phone: "",
                    caller_id: []
                },
                info: {}
            };
        },
        methods: {
        async getData() {
            let _this = this;
            let url = `/seminars/guests?page=${this.currentPage}&&phone=${this.search.phone}&&caller_id=${this.search.caller_id}&&sans_id=${this.$route.params.id}&&present=1`;
            axios
                .get(url)
                .then(function(response) {
                    _this.$store.state.loading = false;
                    _this.data = response.data.data.data;
                    _this.shuffle(_this.data);
                    _this.total = response.data.data.total;
                    _this.currentPage = response.data.data.current_page;
                })
                .catch(function(err) {
                    _this.$root.handleAxiosError(err);
                });
        },
        
           shuffle(array) {
  return array.sort(() => Math.random() - 0.5);
},
            handleChange(){
            },
             showModal() {
                this.visible = true;
            },
          
            defaulProfit() {
                let choosedRole = this.roles.find(x => x.id == this.seminar_role);
                this.info.profit_percent = choosedRole.profit_percent;
                //    return this.roles.find(x => x.id == this.seminar_role);
            },
            handleOk(e) {
                this.loading = true;
                setTimeout(() => {
                    this.visible = false;
                    this.loading = false;
                }, 3000);
            },
            handleCancel(e) {
                this.visible = false;
            },
         
        },
        mounted() {
            this.getData();
        },
    };
</script>

<style scope>
    .pagination {
        display: flex;
        justify-content: center;
        margin: 15px;
    }
</style>
